import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.LOG_OUT
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/logout.js